import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useBackupDaysStore } from '@/stores/useBackupDaysStore'
import { BackupDaysMatrixTable } from './BackupDaysMatrixTable'

/**
 * View / manage the "Shipping, Rail & Truck Backup Days Matrix" as a dialog,
 * opened from the Dynamic value chooser. Mounted once in CltWizard. The table
 * itself is shared with the standalone admin page (BackupDaysMatrixTable).
 */
export function BackupDaysMatrixDialog() {
  const isOpen = useBackupDaysStore(s => s.isOpen)
  const close = useBackupDaysStore(s => s.close)

  return (
    <Dialog open={isOpen} onOpenChange={next => !next && close()}>
      <DialogContent className="sm:max-w-[620px]">
        <DialogHeader>
          <DialogTitle>
            Shipping, Rail &amp; Truck Backup Days Matrix
          </DialogTitle>
          <DialogDescription>
            Preloaded transit days per origin &amp; DC. Edit the Rail and Truck
            legs separately; Shipping is system-managed (read-only). A “Dynamic”
            rule resolves its offset from these values.
          </DialogDescription>
        </DialogHeader>

        <BackupDaysMatrixTable />
      </DialogContent>
    </Dialog>
  )
}
